import { onChange, store } from 'store';
import eventEmitter from '../eventEmitter/EventEmitter';
import basketRepository from '../repositories/BasketRepository';

const basketStore = {
  store: store({
    products: [],
    syncProducts: [],
    basketTotalPrice: 0,
    basketId: '',
    customerId: '',
    isBasketCreating: false,
    promocode: '',
    quantity: 1,
  }),

  setProducts: (value: any): void => {
    basketStore.store.products = value;
    basketStore.setSyncProducts(value.map((item: any) => item.productId));
    basketRepository.setBasketProductsToStorage(basketStore.store.syncProducts);
  },

  setTotal: (value: number): void => {
    basketStore.store.basketTotalPrice = value;
  },

  setPromocode: (value: string): void => {
    basketStore.store.promocode = value;
  },

  setQuantity: (value: number): void => {
    basketStore.store.quantity = value;
  },

  setSyncProducts: (value: any): void => {
    basketStore.store.syncProducts = value;
  },

  setBasketId: (value: string): void => {
    basketStore.store.basketId = value;
    basketRepository.setBasketIdToStorage(value);
  },

  setCustomerId: (value: string): void => {
    basketStore.store.customerId = value;
    basketRepository.setCustomerIdToStorage(value);
  },

  setIsBasketCreating: (value: boolean): void => {
    basketStore.store.isBasketCreating = value;
  },
};

onChange(basketStore.store, (localStore: typeof basketStore.store): void => {
  eventEmitter.emit('basket-store-changed', localStore);
});

basketRepository.setStorageListenerForBasket();

export const initBasketStore = (): void => {
  const customerId = basketRepository.getCustomerIdFromStorage();
  const basketId = basketRepository.getBasketIdFromStorage();

  if (customerId) {
    basketStore.setCustomerId(customerId);
  }

  if (basketId) {
    basketStore.setBasketId(basketId);
  }
};

export default basketStore;
